import { accountsOrigin } from "./accounts";

export type StoryAccount = {
  user: {
    id: string;
    name?: string;
    email?: string;
    image?: string;
  };
};

const authOrigin = import.meta.env.VITE_STORY_AUTH_ORIGIN?.trim()
  || (import.meta.env.VITE_STORY_ENVIRONMENT === "preview" ? "https://auth.mcp-preview.xhalo.co" : "https://auth.xhalo.co");

async function jsonRequest<T>(origin: string, path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${origin.replace(/\/$/u, "")}${path}`, {
    ...init,
    credentials: "include",
    cache: "no-store",
    headers: { accept: "application/json", ...(init.headers ?? {}) },
  });
  const payload = await response.json().catch(() => null) as ({ ok?: boolean } & T) | null;
  if (!response.ok || !payload?.ok) throw new Error(`ACCOUNT_REQUEST_FAILED_${response.status}`);
  return payload;
}

export async function loadStoryAccount(locale: string): Promise<StoryAccount> {
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).get("demo") === "1") {
    return { user: { id: "design-preview", name: "Faye Story", email: "faye@xhalo.co" } };
  }
  return jsonRequest<StoryAccount>(authOrigin, `/api/me?locale=${encodeURIComponent(locale)}`);
}

export async function signOutStoryAccount(): Promise<void> {
  await jsonRequest(authOrigin, "/api/auth/sign-out", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({}),
  });
}

export async function loadChatUnread(): Promise<number> {
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).get("demo") === "1") return 3;
  const raw = document.cookie.split("; ").find((entry) => entry.startsWith("xhalo_chat_unread="))?.split("=")[1];
  const count = Number.parseInt(raw || "0", 10);
  return Number.isFinite(count) ? Math.max(0, Math.min(100, count)) : 0;
}

export const storyAccountsOrigin = accountsOrigin;
export const storyChatOrigin = "https://chat.xhalo.co";
